export default __webpack_public_path__ + "static/media/ss2new.07704a6d.png";